var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfilePic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 95,
    height: 95,
    viewBox: "0 0 95 95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1375",
    "data-name": "Group 1375",
    transform: "translate(-4088 392)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_414",
    "data-name": "Rectangle 414",
    width: 95,
    height: 95,
    transform: "translate(4088 -392)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1374",
    "data-name": "Group 1374",
    transform: "translate(4105.13 -374.827)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "iconmonstr-user-circle-thin",
    d: "M30.062,0A30.062,30.062,0,1,1,0,30.062,30.076,30.076,0,0,1,30.062,0ZM50.421,48.625c-.706-1-1.934-1.638-4.068-2.129-9.64-2.27-10.264-3.76-10.9-5.158a5.478,5.478,0,0,1,.514-4.953c4.324-8.159,5.236-15.091,2.573-19.515-1.688-2.8-4.7-4.344-8.475-4.344-3.81,0-6.844,1.568-8.54,4.417-2.671,4.482-1.736,11.383,2.628,19.433A5.449,5.449,0,0,1,24.7,41.32C24.037,42.788,23.17,44.3,13.766,46.5c-2.134.491-3.362,1.125-4.066,2.124a27.539,27.539,0,0,0,40.721.005Zm1.628-1.959a27.557,27.557,0,1,0-43.978-.005A9.534,9.534,0,0,1,13.2,44.053c5.073-1.157,8.457-2.094,9.214-3.763a3.124,3.124,0,0,0-.471-2.723c-4.8-8.856-5.717-16.637-2.58-21.908,2.137-3.585,6.032-5.639,10.695-5.639,4.622,0,8.495,2.024,10.622,5.556,3.134,5.208,2.245,13.014-2.505,21.98A3.148,3.148,0,0,0,37.73,40.3c.764,1.673,4.118,2.6,9.186,3.755a9.5,9.5,0,0,1,5.133,2.613Z",
    transform: "translate(0 0)",
    fill: "#2f3e68",
    fillRule: "evenodd",
    opacity: 0.336
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilePic);
export default __webpack_public_path__ + "static/media/profile_pic.f1602c090c999f526bdcf03f10f583bd.svg";
export { ForwardRef as ReactComponent };